import moment                from 'moment';
import * as jstimezonedetect from 'jstimezonedetect';

// This function generates a UTC timestamp for the current point in time, useful for outgoing messages (and faked incoming messages).
// These timestamps are used by Moment.js to create the 'live' timestamps on our message feed

// createTimestamp() >> '2017-01-13T10:55:35-00:00'

export const createTimestamp = () => moment.utc().format('YYYY-MM-DD HH:mm:ss');

// This function returns the user's local timezone
// Useful to convert UTC times stored in the db to display accurate local times in the app

// getTimeZone() >> 'America/Toronto'

export const getTimeZone = () => jstimezonedetect.determine().name();

// This function takes in a time string and converts it to the nearest quarter of an hour
// Used in the log activity form to convert inputted times to 15 minute intervals

// roundTimeToQuarter('15:35') >> '15:45'

export const roundTimeToQuarter = (time: string) => {
    if (!time || !time.match(/\d\d:\d\d/)) {
        return time;
    }

    const hours = parseInt(time.substr(0, 2), 10);
    const minutes = parseInt(time.substr(3, 2), 10);

    const remainder: number = 15 - minutes % 15;

    if (remainder === 15) {
        return time;
    }

    let newHours = hours;
    let newMinutes = minutes + remainder;

    if (newMinutes === 60) {
        newHours = hours === 23 ? 0 : hours + 1;
        newMinutes = 0;
    }

    const formattedHours = (newHours + '').match(/\d\d/) ? newHours : '0' + newHours;
    const formattedMinutes = (newMinutes + '').match(/\d\d/) ? newMinutes : '0' + newMinutes;

    const newTime = formattedHours + ':' + formattedMinutes;

    return newTime;
};

export default roundTimeToQuarter;



// WEBPACK FOOTER //
// ./src/helpers/timeUtils.ts